import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var OfficeChairIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3.078 2.614A1 1 0 014 2h5c1.437 0 2.308 1.196 2.817 2.275.546 1.157.914 2.66 1.169 4.144.078.457.154 1.145.223 1.775l.004.037.087.769h4.2a2.5 2.5 0 010 5H13v4.22l3.242.81a1 1 0 11-.485 1.94L12 22.03l-3.757.94a1 1 0 11-.486-1.94L11 20.22V16H7a1 1 0 01-.988-.846L5.015 8.76c-.25-1.296-.465-2.349-.742-3.211-.277-.863-.59-1.446-.986-1.848a1 1 0 01-.21-1.087zM5.826 4c.132.3.247.614.351.937.322 1 .557 2.178.805 3.462a.972.972 0 01.006.035L7.856 14H17.5a.5.5 0 000-1h-5.071a1 1 0 01-.984-.82c-.074-.403-.147-1.07-.216-1.695l-.004-.035a34.275 34.275 0 00-.21-1.693c-.246-1.427-.578-2.718-1.007-3.628C9.542 4.142 9.163 4 9 4H5.826z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
OfficeChairIcon.isCarinaIcon = true;
export default OfficeChairIcon;
